export enum FeedbackType {
  Positive = 1,
  Negative = 2,
}

export type Exchange = {
  result?: string;
  answerDatetime?: Date;
  question?: string;
  questionDatetime: Date;
  questionUuid?: string;
  pageLinks?: string[];
  pageNumbers?: number[];
  feedbackType?: FeedbackType;
  feedback?: string;
  feedbackText?: string;
  chatSessionID?: string;
  summarizedResult?: string;
  detailedResult?: string;
  streaming?: boolean;
  detailedLoading?: boolean;
};
